import { DataSource, Layout, Table } from "@mcleod/components";

export abstract class AutogenLayoutLoadboardUsersDat extends Layout {
    sourcePbwLoadboardUsers: DataSource;
    tablePbwUserDat: Table;
}
